// Abrir / cerrar hotspots
document.querySelectorAll('.fip__hotspot').forEach((hotspot) => {
  const dot = hotspot.querySelector('.fip__dot');

  dot.addEventListener('click', (e) => {
    e.stopPropagation();
    const isOpen = hotspot.classList.contains('is-open');

    document.querySelectorAll('.fip__hotspot.is-open').forEach((h) => {
      h.classList.remove('is-open');
    });

    if (!isOpen) hotspot.classList.add('is-open');
  });
});

document.addEventListener('click', () => {
  document.querySelectorAll('.fip__hotspot.is-open').forEach((h) => {
    h.classList.remove('is-open');
  });
});

// Agregar al carrito
document.querySelectorAll('.fip__atc-btn').forEach((btn) => {
  btn.addEventListener('click', async (e) => {
    e.stopPropagation();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('is-loading');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (res.ok) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');

        // Notifica al cart drawer/bubble del tema Dawn
        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

            // Compatibilidad con Dawn: abre el cart drawer si existe
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents({ target: { closest: () => null } });
            }

            // Actualiza el burbuja del icono del carrito
            const cartBubble = document.querySelector('.cart-count-bubble');
            if (cartBubble) {
              const countEl = cartBubble.querySelector('[aria-hidden]');
              if (countEl) countEl.textContent = cart.item_count;
              cartBubble.classList.remove('hidden');
            }
          });

        setTimeout(() => {
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 2500);
      } else {
        throw new Error('Error al agregar');
      }
    } catch {
      btn.classList.remove('is-loading');
      btn.disabled = false;
      alert('No se pudo agregar al carrito. Intenta de nuevo.');
    }
  });
});
